module.exports = __webpack_public_path__ + "assets/img/1001587020623_.pic_hd.261b3136.jpg";